@if (listType == 'bullet') {
  <div>
    <ul>
      @for (item of listItems; track item) {
        <li>
          {{ item }}
        </li>
      }
    </ul>
  </div>
} @else {
  <div>
    <ol>
      @for (item of listItems; track item) {
        <li>
          {{ item }}
        </li>
      }
    </ol>
  </div>
}

